/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const isServer = typeof window === 'undefined';
export const withDynamicImport = ({ server, client, name, placeholder }) => {

  if (isServer) return server();

  const Component = (props) => {
    const moduleRef = useRef(null);
    const [_, forceRender] = useState();

    useEffect(() => {
      client().then((module) => {
        moduleRef.current = module[name];
        if (!moduleRef.current) {
          // eslint-disable-next-line max-len
          throw new Error(`Error importing ${name} in withDynamicImport. Make sure module name matches component export name.`);
        }

        Component.dataModel = moduleRef.current?.dataModel || {};
        forceRender(new Date().getTime());
      });
    }, []);
    if (!moduleRef.current) return placeholder || null;
    const queryProviderProps = (props.queryProvider || {});
    return (
      <QueryProvider
        defaultVariables={props?.qctx?.defaultVariables?.current}
        {...queryProviderProps}
        cacheKey={`dynamic-import-${name}`}
      >
        <moduleRef.current
          {...props}
        />
      </QueryProvider>
    );
  };

  Component.displayName = name;

  return Component;
};
